import { render, staticRenderFns } from "./videoonlinecourse.vue?vue&type=template&id=db4b0d38&scoped=true&"
import script from "./videoonlinecourse.vue?vue&type=script&lang=js&"
export * from "./videoonlinecourse.vue?vue&type=script&lang=js&"
import style0 from "./videoonlinecourse.vue?vue&type=style&index=0&id=db4b0d38&scoped=true&lang=scss&"
import style1 from "./videoonlinecourse.vue?vue&type=style&index=1&id=db4b0d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b0d38",
  null
  
)

export default component.exports